/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdhocContact
 */
export interface AdhocContact {
    /**
     * 
     * @type {string}
     * @memberof AdhocContact
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AdhocContact
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdhocContact
     */
    role: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdhocContact
     */
    email: string | null;
}

/**
 * Check if a given object implements the AdhocContact interface.
 */
export function instanceOfAdhocContact(value: object): value is AdhocContact {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AdhocContactFromJSON(json: any): AdhocContact {
    return AdhocContactFromJSONTyped(json, false);
}

export function AdhocContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdhocContact {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'name': json['name'],
        'role': json['role'],
        'email': json['email'],
    };
}

export function AdhocContactToJSON(value?: AdhocContact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'name': value['name'],
        'role': value['role'],
        'email': value['email'],
    };
}

